export function SerialModel () {
    this.campaignImgUrl = '';
    this.campaignName = '';
    this.currentTimestamp = '';
    this.expireIn = '';
    this.privilegeMessage = '';
    this.privilegeMessageFormat = '';
    this.redeemTimestamp = '';
    this.serial = '';
    this.serialType = '';
    this.expireDate = '';

    this.setModelFromDataModel = dict => {
        this.campaignImgUrl = dict.fullImageUrl || '';
        this.campaignName = dict.name || '';
        this.expireIn = dict.expireIn || 0;
        this.privilegeMessage = dict.privilegeMessage || '';
        this.privilegeMessageFormat = dict.privilegeMessageFormat | '';
        this.redeemTimestamp = dict.redeemDate || '';
        this.serial = dict.serial || '';
        this.serialType = dict.barcode || '';
        this.expireDate = dict.expireDate || dict.voucherExpireDate || '';
    };
}
